// extracted by mini-css-extract-plugin
export default {"infoBlock":"mTiR6RSuGHJ7X9mSLIxJ","infoText":"uUEVJkjJP8dH_Pvih91u","buttonBlock":"jS7HFPcHoqyEltILnfQ7","footerText":"xbKNRQE5eOGkZtS4km2p"};